import { render } from "./SettingsWarning.vue?vue&type=template&id=eaa9fda2"
import script from "./SettingsWarning.vue?vue&type=script&lang=js"
export * from "./SettingsWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__